import { computed, ComputedRef } from 'vue'

import localeToConditionsUrl from "../../../config/localeToConditionsUrl"

// State
import store from "@/vue/planning/store/store"
import getSiteFromDomain from '../logic/getSiteFromDomain'

const conditionsUrl: ComputedRef<string> = computed(() => {
    const locale: string = store.getters['locale']
    const formattedLocale: string = locale.replaceAll("-", "_")
    // const url = localeToConditionsUrl[formattedLocale]
    const url =`https://docs.travelski.com/legal-docs/${getSiteFromDomain(window.location.hostname, locale)}/CGV/index.pdf`
    if (!url) throw new Error("could not get conditions url for locale: " + formattedLocale)
    return url + `?ts=${Date.now()}`
})

export default conditionsUrl